jQuery(function(){

    jQuery('body').on('click', '#cancel-reference-cta', function(e){
        e.preventDefault();
        var $form = jQuery('#cancellation-reference-form');
        var form = $form.parsley();

        form.validate();
		if(form.isValid()) {
            window.location = '/auto/repair/vehicle-inspection/cancel/confirm';
        }

        return false;
    });

    jQuery('body').on('click', '#cancel-appointment-cta', function(e){
        e.preventDefault();

        window.location = '/auto/repair/vehicle-inspection/cancel/complete';

        return false;
    });


    jQuery('body').on('click', '#cancel-appointment-cancel-cta', function(e){
        e.preventDefault();

        window.location = '/auto/repair/vehicle-inspection/cancel';

        return false;
    });


    jQuery('body').on('click', '#cancel-appointment-print-cta', function(e){
        e.preventDefault();
        window.print();

        return false;
    });

});